import { alpha, Select, styled } from '@mui/material';
import { FONT_MONO } from 'themes/tokens';

export const RevisionSelect = styled(Select)(({ theme }) => ({
  fontFamily: FONT_MONO,
  fontSize: '0.78rem',
  fontWeight: 600,
  borderRadius: '8px',
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  '& .MuiSelect-select': { padding: theme.spacing(0.75, 3, 0.75, 1.25) },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: alpha(theme.palette.info.main, 0.24) },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: alpha(theme.palette.info.main, 0.45) },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
  '& .MuiSelect-icon': { color: theme.palette.info.main },
}));
